import gql from 'graphql-tag';

export const onboardingVerificationShowCapDepStepQuery = gql`
  query OnboardingVerificationShowCapDepStepQuery {
    onboardingVerificationShowCapDepStep @client
  }
`;

export const verificationHomeQuery = gql`
  query VerificationHomeQuery($companyProfileId: ID!) {
    viewer {
      uid
      companyUser(companyProfileId: $companyProfileId) {
        companyUserId
        isAllowedToSkipPOA
        isPrimaryApplicant
        kycAddressStatus
        kycIdStatus
        updatedAt
      }
      company: application(companyProfileId: $companyProfileId) {
        applicationId
        companyProfileId
        isCapitalDeposit
        isMultiKYC
        isShineStart
        profile: onboardingCompanyProfile {
          applicationId
          companyProfileId
        }
        capitalDeposit {
          capitalDepositId
          partner
          isConfirmedPartner
        }
        lastKybReview {
          kybReviewId
          error
          updatedAt
        }
      }
      metadata {
        uid
        hasAgreedToTermsOfService
        updatedAt
      }
      profile {
        uid
        isSpecifiedUSPerson
        hasForeignFiscalResidence
        personalAssets
        incomeRange
        updatedAt
      }
      outstandingAgreements(companyProfileId: $companyProfileId) {
        agreementId
        type
        status
        updatedAt
      }
    }
  }
`;

export const verificationHomePrimaryApplicantQuery = gql`
  query VerificationHomePrimaryApplicantQuery($companyProfileId: ID!) {
    onboardingVerificationShowCapDepStep @client
    viewer {
      uid
      company: application(companyProfileId: $companyProfileId) {
        applicationId
        companyProfileId
        capitalDeposit {
          capitalDepositId
          status
          updatedAt
        }
        kybDocuments {
          kybDocumentId
          type
          status
          updatedAt
        }
        metadata {
          companyProfileId
          willBeOnboardedAs
          selectedPlanId
          updatedAt
        }
        profile: onboardingCompanyProfile {
          applicationId
          companyProfileId
          legalForm
        }
        shineStart {
          shineStartId
          status
          stepStatus
          isPaid
          updatedAt
        }
      }
    }
    companyLegalBeneficiaries(companyProfileId: $companyProfileId) {
      companyLegalBeneficiaryId
      isCurrentUser
      onboardingStatus
      updatedAt
    }
  }
`;
